import { Link } from 'react-router-dom'

import { Card, EmptyState } from '@/design'
import { GA4_INTEGRATION_ROUTE } from '@/features/ga4-shared/route'
import { usePermissions } from '@/lib/access'

import { trafficErrorMessage } from './errors'

/** Nothing connected (or nothing configured): the fix is on the Integrations page, if this role can reach it. */
export function NoProperty() {
  const { can } = usePermissions()
  return (
    <Card>
      <EmptyState
        variant="disconnected"
        title="No Google Analytics property connected"
        description={
          can('integrations.manage')
            ? 'Connect a GA4 property to see where your sessions and conversions come from.'
            : 'An Owner or Administrator can connect a GA4 property in Settings › Integrations.'
        }
        action={
          can('integrations.manage') ? (
            <Link className="ci-button" data-variant="primary" to={GA4_INTEGRATION_ROUTE}>
              Connect Google Analytics
            </Link>
          ) : undefined
        }
      />
    </Card>
  )
}

export function NoRows({ from, to }: { from: string; to: string }) {
  return (
    <Card>
      <EmptyState
        variant="no-results"
        title="No traffic in this period"
        description={`Google Analytics reported no sessions from ${from} to ${to}. Traffic is imported up to yesterday; try a wider date range.`}
      />
    </Card>
  )
}

const UNAVAILABLE = 'Google Analytics traffic is temporarily unavailable. Try again in a moment.'

export function TrafficError({ error }: { error: unknown }) {
  return (
    <Card>
      <EmptyState variant="outage" title="Traffic could not be loaded" description={trafficErrorMessage(error, UNAVAILABLE)} announce />
    </Card>
  )
}
